export const ADD_AUCTIONS = 'addAuctions';
export const UPDATE_AUCTIONS = 'updateAuctions';
export const REMOVE_AUCTIONS = 'removeAuctions';
export const CLEAR_AUCTIONS = 'clearAuctions';
export const UPDATE_SELECTED_AUCTION_LANE = 'updateSelectedAuctionLane';
export const UPDATE_SELECTED_AUCTION_LANE_SUB_FILTER = 'updateSelectedAuctionLaneSubFilter';
export const SET_SYNC_AUCTIONS_DATA_REQUEST = 'setSyncAuctionsDataRequest';
export const ADD_AUCTION_ID_TO_WAITING_FOR_SYNC_COLLECTION = 'addAuctionIdToWaitingForSyncCollection';
export const ADD_AUCTION_IDS_TO_WAITING_FOR_SYNC_COLLECTION = 'addAuctionIdsToWaitingForSyncCollection';
export const CLEAR_AUCTION_IDS_WAITING_FOR_SYNC_COLLECTION = 'clearAuctionIdsToWaitingForSyncCollection';
export const UPDATE_AD_HOC_SEARCH_IS_ACTIVE = 'updateAdHocSearchIsActive';
export const UPDATE_SAVED_SEARCH_IS_ACTIVE = 'updateSavedSearchIsActive';
export const UPDATE_LAST_SYNC_AUCTIONS_DATA_REQUEST_TIMESTAMP = 'updateLastSyncAuctionsDataRequestTimestamp';
export const UPDATE_HAS_MORE_PAGES = 'updateHasMorePages';
export const UPDATE_AUCTION_LANES_REFRESHING = 'updateAuctionLanesRefreshing';
export const UPDATE_VIEWING_AUCTION_MODEL = 'updateViewingAuctionModel';
export const UPDATE_LEGACY_AUCTION_RANK_IN_LIST = 'updateLegacyAuctionRankInList';
export const RETAIN_GRAPHQL_SUBSCRIPTION = 'retainGraphqlSubscription';
export const REMOVE_GRAPHQL_SUBSCRIPTION_BY_AUCTION_IDS = 'removeGraphqlSubscriptionByAuctionIds';
export const UPDATE_AUCTION_BID_INCREMENT = 'updateAuctionBidIncrement';
export const UPDATE_VIEWING_AUCTION_BID_INCREMENT = 'updateViewingAuctionBidIncrement';
